import { COLORS } from '../../../styles/tokens';

// Stiler som deles av valgene på Mengde-siden (bilkortet og lasteutstyrskortet).
export const choice = {
  card:    { background: COLORS.white, border: `1px solid ${COLORS.border}`, borderRadius: 16, padding: '12px 14px', marginTop: 12 },
  title:   { fontWeight: 700, fontSize: 14.5, color: COLORS.textDark, margin: '0 0 10px' },
  label:   { display: 'block', fontSize: 12, fontWeight: 600, color: COLORS.textMid, margin: '0 0 6px' },
  hint:    { fontSize: 12, color: COLORS.textMid, lineHeight: 1.4, margin: '6px 0 0' },
  pills:   { display: 'flex', flexWrap: 'wrap', gap: 6 },
  pill:    { padding: '9px 14px', borderRadius: 99, fontSize: 13.5, fontWeight: 600, cursor: 'pointer',
             border: `1px solid ${COLORS.border}`, background: COLORS.white, color: COLORS.textDark },
  pillOn:  { border: `1px solid ${COLORS.brandPanel}`, background: COLORS.brandPanel, color: '#fff' },
  divider: { borderTop: `1px solid ${COLORS.border}`, margin: '10px 0' },
  link:    { background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: 12.5, fontWeight: 600, color: COLORS.textDark, textDecoration: 'underline' },
  sum:     { fontSize: 13.5, fontWeight: 700, color: COLORS.textDark, margin: 0 },
  warning: { marginTop: 8, fontSize: 13, color: COLORS.dangerText },
};
